export const CONFIG = {
  FIELD_TYPES_WITH_OPTIONS: ["select", "radio", "checkbox-group"] as const,
  MAX_RECURSION_DEPTH: 20,
  IGNORED_KEYS: [
    "impactedFields",
    "validators",
    "ui",
    "decorator",
    "options",
  ] as const,
  DEFAULTS: {
    STEP_INDEX: -1,
    SECTION_INDEX: -1,
    SUB_SECTION_INDEX: -1,
    ROW_INDEX: -1,
  },
};
